import { useEffect, useState } from "react";

export function useErrorModal(error: unknown, refetch: () => void) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (error) setOpen(true);
  }, [error]);

  function handleRetry() {
    setOpen(false);
    refetch();
  }

  return { open, setOpen, handleRetry };
}
